'use client';

import { ctaContainerStyles } from '@/blocks/PricingCards/styles';
import { ButtonColors, ButtonVariants } from '@/components/atoms/Button';
import LinkButton from '@/components/atoms/LinkButton';
import { useTrackPricingCardClick } from '@/hooks/useTrackPricingCardClick';
import { cn } from '@/lib/utils';
import { usePathname } from 'next/navigation';
import { createHrefWithExperimentTracking } from './utils';

export type PricingCardCTAProps = {
  url: string;
  text: string;
  variant?: ButtonVariants;
  color?: ButtonColors;
  trackEventName: string;
  trackId: string;
  trackExtra?: Record<string, unknown>;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  className?: string;
  dataTrackerComponent?: string;
  buttonClassNames?: {
    root?: string;
    inner?: string;
    leftSection?: string;
    rightSection?: string;
  };
};

export default function PricingCardCTA({
  url,
  text,
  variant = 'filled',
  color = 'primary',
  trackEventName,
  trackId,
  trackExtra,
  leftSection,
  rightSection,
  className,
  dataTrackerComponent,
  buttonClassNames,
}: PricingCardCTAProps) {
  const pathname = usePathname();
  const handleClick = useTrackPricingCardClick({
    trackEventName,
    trackId,
    trackExtra,
  });

  return (
    <div
      className={cn(ctaContainerStyles, className)}
      data-tracker-component={dataTrackerComponent}
      onClick={() => handleClick()}
    >
      <LinkButton
        data-tracker-context={trackId}
        href={createHrefWithExperimentTracking(url, pathname)}
        variant={variant}
        color={color}
        slim={false}
        fullwidth
        openInNewTab={false}
        leftSection={leftSection}
        rightSection={rightSection}
        classNames={{
          root: buttonClassNames?.root,
          inner:
            buttonClassNames?.inner || 'flex items-center justify-center gap-4',
          leftSection: buttonClassNames?.leftSection,
          rightSection: buttonClassNames?.rightSection,
        }}
      >
        {text}
      </LinkButton>
    </div>
  );
}
